import { Component, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { ModalService } from 'src/app/service/modal.service';
import { GroupValidator } from 'src/app/validator/group-validator';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';
import { HttpParams } from '@angular/common/http';
import { SupportPage } from '../../../model/page/support-page';
import { ContentfulService } from '../../../service/contentful.service';
import { ConfigService } from '../../../service/config.service';
import { CommonModalComponent } from '../../section/common-modal/common-modal.component';
import { entraAuthService } from 'src/app/service/auth.service';
import { ApiService } from 'src/app/service/api.service';

@Component({
  selector: 'app-support-page',
  templateUrl: './support-page.component.html',
  styleUrls: ['./support-page.component.scss']
})
export class SupportPageComponent implements OnInit {
  supportPage: SupportPage = {} as SupportPage;
  isUserLoggedIn = false;
  userId = '';
  technicalOperationSubscribed = false;

  constructor(private contentfulService: ContentfulService,private authService: entraAuthService,private apiService: ApiService,private modalService: ModalService, private configService: ConfigService) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'support') {
        this.supportPage.htmlTitle = title.htmlTitle;
      }
    });
    this.supportPage.sections = [];
    this.supportPage.justBelowBannerSections = [];
    this.supportPage.supportCards = [];
    this.supportPage.outageBanners = [];
    this.supportPage.subscribeUrl = '';

    const query = { 'fields.title': 'SUPPORT' };
    this.contentfulService.getPageContentResponse(query).then((supportPageEntries) => {
      this.mapHtmlTitle(supportPageEntries.items);
      this.mapBanner(supportPageEntries.includes.Entry);
      this.mapOutageBanners(supportPageEntries.includes.Entry);
      this.mapCards(supportPageEntries.includes.Entry);
      this.mapSections(supportPageEntries.includes.Entry);
    });
      let token = this.authService.isLoggedIn();

    if (token) {
      const user = this.parseUserInfo();
      if (user) {
        this.userId = user.userID || user.userId;
      }
      this.isUserLoggedIn = true;
      this.getUserInformation(this.userId);
    } else {
      this.isUserLoggedIn = false;
    }
  }

  openLoginModal() {
    this.modalService.openModal(CommonModalComponent);
  }

  private parseUserInfo(): any {
    try {
      const raw = localStorage.getItem('user_info');
      const parsed = raw ? JSON.parse(raw) : null;
      return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : null;
    } catch {
      return null;
    }
  }

  private mapHtmlTitle(items: Entry<any>[]) {
    items.forEach((entry: any) => {
      this.supportPage.htmlTitle = entry.fields.htmlTitle;
    });
  }

  private mapBanner(supportPageEntries: Entry<any>[]) {
    supportPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let imageDetails: any = entry.fields['image'];
    let videoDetails: any = entry.fields['video'];
    this.supportPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: imageDetails.fields.file.url as string,
      video: videoDetails?.fields?.file?.url as string
    };
  }

  private mapOutageBanners(supportPageEntries: Entry<any>[]) {
    supportPageEntries
      .filter((entry) => ModelValidator.isNote(entry))
      .forEach((entry) => {
        this.mapEntryToOutageBanner(entry);
      });
  }

  private mapEntryToOutageBanner(entry: Entry<any>) {
    this.supportPage.outageBanners.push({
      title: entry.fields['title'] as string,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      category: entry.fields['category'] as string,
      order: entry.fields['order'] as number,
      fullTitle: '',
      iconClass: entry.fields['iconClass'] as string
    });
    this.supportPage.outageBanners.sort((a, b) => a.order - b.order);
  }

  private mapSections(supportPageEntries: Entry<any>[]) {
    supportPageEntries
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        this.mapEntryToSection(entry);
      });

    this.supportPage.justBelowBannerSections = this.supportPage.sections.filter((section) => GroupValidator.isJustBelowBanner(section.group));
    this.supportPage.justBelowBannerSections.sort((a, b) => a.order - b.order);
  }

  private mapEntryToSection(entry: Entry<any>) {
    let givenTitle: any = entry.fields['title'] as string;
    let pageTitle = givenTitle.split('#').pop();
    this.supportPage.sections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number
    });
  }

  private mapCards(supportPageEntries: Entry<any>[]) {
    supportPageEntries
      .filter((entry) => ModelValidator.isCard(entry))
      .forEach((entry, index) => {
        this.mapEntryToSupportCards(entry);
      });

    this.supportPage.supportCards.sort((a, b) => a.order - b.order);
  }

  private mapEntryToSupportCards(entry: Entry<any>) {
    let headImageDetails: any = entry.fields['headImage'];
    this.supportPage.supportCards.push({
      order: entry.fields['order'] as number,
      headImage: headImageDetails.fields.file.url,
      headIconClass: entry.fields['headIconClass'] as string,
      buttonText: entry.fields['buttonText'] as string,
      url: entry.fields['url'] as string,
      richTextBody: entry.fields['body'] as string,
      cardTitle: entry.fields['title'] as string,
      buttonUrl: entry.fields['buttonUrl'] as string
    });
  }

  redirectToLogin(): void {
    localStorage.setItem('redirect_url', '/profile');
    this.authService.initLogin();
  }
  async getUserInformation(userId: string) {
    const queryParams = new HttpParams()
      .append('id', userId)
    const apiResponse = await this.apiService.sendGetRequest('/user', queryParams);
    if (apiResponse?.success?.emailPreference?.operationalOldAPIUpdates?.toLowerCase() === 'yes' 
     && apiResponse?.success?.emailPreference?.operationalNewAPIUpdates?.toLowerCase() === 'yes') {
      this.technicalOperationSubscribed = true;
    }
  }
}
